import React from 'react';
import { Alert, Button, alpha } from '@mui/material';
import { formatDraftTimestamp } from '../../utils/formDraftStorage';
import { ACCENT, TEXT_PRIMARY } from './SaaSTokens';

const FormDraftNotice = ({ savedAt, onDiscard, onDismiss }) => {
  if (!savedAt) return null;
  return (
    <Alert
      severity="info"
      onClose={onDismiss}
      sx={{
        mb: 2,
        borderRadius: '10px',
        fontFamily: "'DM Sans', sans-serif",
        background: alpha(ACCENT, 0.08),
        border: `1px solid ${alpha(ACCENT, 0.25)}`,
        color: TEXT_PRIMARY,
        '& .MuiAlert-icon': { color: alpha(ACCENT, 0.85) },
      }}
      action={
        onDiscard ? (
          <Button color="inherit" size="small" onClick={onDiscard} sx={{ fontWeight: 600 }}>
            Discard draft
          </Button>
        ) : null
      }
    >
      Restored your saved draft from {formatDraftTimestamp(savedAt)}. Uploaded files are not included in drafts. Discard draft clears the form.
    </Alert>
  );
};

export default FormDraftNotice;
